import Layout from "../../../components/layout";
import MainContent from "../../../components/maincontent";
import React from "react";
import Schedule from "../../../components/schedule/2021/schedule";
import Seo from "../../../components/seo";
import BackButtonInSchedules from "../../../components/navigation/backbuttoninschedules";

const IndexPage = () => (
  <Layout>
    <Seo
      title="Camp 2021 - Schedule"
      description="Schedule for Charity Grace Bible Camp 2021"
      lang="en"
      meta={[
        {
          content: "God, Jesus, Gospel, Heaven, Salvation, Saved, Grace, Free, How, Mid-Acts, Romans, Charity Grace Bible Church, Illinois",
          name: "keywords"
        }
      ]}
    />

    <MainContent
      hasArticle={false}
      hasBanner={false}
    >
     <BackButtonInSchedules  />
     
      <div className="grid--4 grid-padding align--center"  >
        <h2>Camp Schedule 2021</h2>
        <h3>What Is God Doing Today?</h3>
        <span className="caption">October 7th - October 10th</span>
      </div>

      <div className="grid--4 grid-padding align--center"  >
        <a
          href="/assets/pdf/CGBC_2021_Schedule.pdf"
          className="button button--green"
          download=""
        >
          <i className="fa fa-file-pdf-o" aria-hidden="true" /> Download PDF
        </a>
      </div>
    </MainContent>
    <Schedule />
  </Layout>
);

export default IndexPage;
